module.exports = "<Label class=\"form-control-label\" [ngStyle]=\"{'width': width + (width === 'auto' ? '' : 'px')}\">{{label}}</Label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/label/label.component.html
// module id = 1056
// module chunks = 22